import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { QuicklinkModule } from 'ngx-quicklink';
import { VexRoutes } from 'src/@vex/interfaces/vex-route.interface';
import { RouteConstant } from 'src/app/core/common/route-constant';
import { DesaparecidoFormComponent } from './desaparecido/desaparecido-form/desaparecido-form.component';
import { DesaparecidoListComponent } from './desaparecido/desaparecido-list/desaparecido-list.component';
import { GrupoFormComponent } from './grupo/grupo-form/grupo-form.component';
import { GrupoListComponent } from './grupo/grupo-list/grupo-list.component';
import { NotificacionListComponent } from './notificacion/notificacion-list/notificacion-list.component';
import { SocioListComponent } from './socio/socio-list/socio-list.component';
import { ReporteListComponent } from './reporte/reporte-list/reporte-list.component';
import { MonitorListComponent } from './monitor/monitor-list/monitor-list.component';
import { PublicadodoListComponent } from './monitor/publicado-list/publicado-list.component';
import { ConfigComponent } from './monitor/config/config.component';

const routes: VexRoutes = [
  {
    path: RouteConstant.ROUTE_CASE_MISSING.url,
    component: DesaparecidoListComponent
  },
  {
    path: `${RouteConstant.ROUTE_CASE_MISSING.url}/:id`,
    component: DesaparecidoFormComponent
  },
  {
    path: RouteConstant.ROUTE_REPORT_MISSING.url,
    component: ReporteListComponent
  },
  {
    path: RouteConstant.ROUTE_CASE_SOCIO.url,
    component: SocioListComponent
  },
  {
    path: RouteConstant.ROUTE_CASE_GRUPO.url,
    component: GrupoListComponent
  },
  {
    path: `${RouteConstant.ROUTE_CASE_GRUPO.url}/:actionType`,
    component: GrupoFormComponent
  },
  {
    path: `${RouteConstant.ROUTE_CASE_GRUPO.url}/:actionType/:id`,
    component: GrupoFormComponent
  },
  {
    path: RouteConstant.ROUTE_CASE_NOTIFICACION.url,
    component: NotificacionListComponent
  },
  {
    path: RouteConstant.ROUTE_MONITOR.url,
    component: MonitorListComponent
  },
  {
    path: RouteConstant.ROUTE_PUBLISHED.url,
    component: PublicadodoListComponent
  },
  {
    path: RouteConstant.ROUTE_CONFIG.url,
    component: ConfigComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule, QuicklinkModule]
})
export class CasoRoutingModule { }
